import { CorrectInvalidTonnageParam } from './../../Tonnage/api/TonnageApi';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { InvalidTonnageModel } from '../models/InvalidTonnageModel';
import { OrderDirection } from '../../Datatable/OrderDirection';

interface invalidTonnageState {
    invalidTonnageData: InvalidTonnageModel[],
    invalidTonnageDisplay: InvalidTonnageModel[],
    selectedItem: InvalidTonnageModel | null,
    searchText: string,
    orderBy: string,
    orderDirection: OrderDirection,
    refreshInvalidTonnageTable: number,
    openEditInvalidTonnageModal: boolean,
    editItemParam: CorrectInvalidTonnageParam,
}

const initialState: invalidTonnageState = {
    invalidTonnageData: [],
    invalidTonnageDisplay: [],
    selectedItem: null,
    searchText: "",
    orderBy: "updatedDate",
    orderDirection: OrderDirection.Desc,
    refreshInvalidTonnageTable: 0,
    openEditInvalidTonnageModal: false,
    editItemParam: {
        id: "",
        portOpen: 0,
        headOwner: "",
        operator: "",
    }
}

export const InvalidTonnageSlice = createSlice({
    name: "InvalidTonnageInput",
    initialState,
    reducers: {
        setInvalidTonnageData: (state, action: PayloadAction<InvalidTonnageModel[]>) => {
            state.invalidTonnageData = action.payload;
        },
        setInvalidTonnageDisplay: (state, action: PayloadAction<InvalidTonnageModel[]>) => {
            state.invalidTonnageDisplay = action.payload;
        },
        setSelectedItem: (state, action: PayloadAction<InvalidTonnageModel>) => {
            state.selectedItem = action.payload;
        },
        setInvalidTonnageSearchText: (state, action: PayloadAction<string>) => {
            state.searchText = action.payload;
        },
        setInvalidTonnageOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setInvalidTonnageOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.orderDirection = action.payload;
        },
        setRefreshInvalidTonnageTable: (state, action: PayloadAction<number>) => {
            state.refreshInvalidTonnageTable = action.payload;
        },
        setOpenEditInvalidTonnageModal: (state, action: PayloadAction<boolean>) => {
            state.openEditInvalidTonnageModal = action.payload;
        },
        setCorrectInvalidTonnageParam: (state, action: PayloadAction<CorrectInvalidTonnageParam>) => {
            state.editItemParam = action.payload;
        },
    }
});

export const invalidTonnageSelector = createSelector(
    (state: RootState) => state.invalidTonnage,
    (data) => data
);

export const {
    setInvalidTonnageData,
    setInvalidTonnageDisplay,
    setSelectedItem,
    setInvalidTonnageSearchText,
    setInvalidTonnageOrderBy,
    setInvalidTonnageOrderDirection,
    setRefreshInvalidTonnageTable,
    setOpenEditInvalidTonnageModal,
    setCorrectInvalidTonnageParam
} = InvalidTonnageSlice.actions;

export default InvalidTonnageSlice.reducer;